import React, { useState } from 'react';
import { FaHeadset } from "react-icons/fa6";
import { logEvent } from "firebase/analytics";
import { analytics } from "../Firebase";

function BackOfficeFooter() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="back-office-footer">
        <button className="back-office-help-btn" onClick={() => setOpen(true)}>
          <FaHeadset />
        </button>
      </div>

      {open && (
        <div className="notif-overlay" onClick={() => setOpen(false)}>
          <div className="notif-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="notif-title">Besoin d'aide ?</h2>
            <p className="notif-subtitle">
              Notre équipe est disponible pour vous accompagner par WhatsApp.
            </p>
            <div className="notif-actions">
              <button
                type="button"
                className="notif-btn primary"
                onClick={() => {
                  logEvent(analytics, 'help_whatsapp');
                  window.open('https://wa.me/message/NR5ALYUJYWENM1', '_blank', 'rel=noopener noreferrer');
                }}
              >
                Contacter sur WhatsApp
              </button>
              <button
                type="button"
                className="notif-btn secondary"
                onClick={() => setOpen(false)}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BackOfficeFooter;
